import {
  SET_BROWSE_BY,
  SET_BROWSE_BY_FACET,
  SET_SORTS,
  SET_LOAD_MORE,
  SET_POPSTATE,
  SET_FILTERS,
  APPLY_FILTER,
  APPLY_SORT,
  CLEAR_FILTERS,
  SET_FIRST_QUERY,
} from '@/context/recipeFilter/types';

export const setBrowseBy = payload => ({
  type: SET_BROWSE_BY,
  payload,
});

export const setBrowseByFacet = payload => ({
  type: SET_BROWSE_BY_FACET,
  payload,
});

export const setSorts = payload => ({
  type: SET_SORTS,
  payload,
});

export const setLoadMore = payload => ({
  type: SET_LOAD_MORE,
  payload,
});

export const setPopstate = payload => ({
  type: SET_POPSTATE,
  payload,
});

export const setFilters = payload => ({
  type: SET_FILTERS,
  payload,
});

export const applyFilter = payload => ({
  type: APPLY_FILTER,
  payload,
});

export const applySort = payload => ({
  type: APPLY_SORT,
  payload,
});

export const clearFilters = payload => ({
  type: CLEAR_FILTERS,
  payload,
});

export const setFirstQuery = payload => ({
  type: SET_FIRST_QUERY,
  payload,
});
